module.exports = __webpack_public_path__ + "img/isExpired.0252222f.png";